import Lemonade1 from '../../Media/Produk/Grand Lemonade.webp'
import Lemonade2 from '../../Media/Produk/Grand Lemonade.webp'



const Lemonadeimages =[
    Lemonade1,Lemonade2
]

export default Lemonadeimages;